<template>
  <v-layout class="product">
    <v-flex xs3 sm2 class="product-img">
      <v-img
        :src="product.photourl ? product.photourl.split(';;')[0] : ''"
        alt="product.name"
        class="img-responsive grey lighten-2"
        lazy
        aspect-ratio="1"
        :lazy-src="require(`@/assets/img/products/default-photo.png`)"
      />
    </v-flex>
    <v-flex xs9 sm10 class="detail pl-2 pr-2">
      <div class="name small">
        {{ product.name }}
        <template v-if="product.option">({{ product.option }})</template>
        x {{ product.quantity }}
      </div>
      <div class="warning--text" v-if="product.addon_json">
        <template
          v-if="
            pageProfile.type == 'reka' &&
            product.addon_json &&
            product.addon_json.embroideredNameList &&
            product.addon_json.embroideredNameList.length > 0
          "
        >
          <template
            v-for="(item, index) in product.addon_json.embroideredNameList"
          >
            <div :key="index">
              ปักชื่อ ({{ index + 1 }}) +฿100 :<br />
              <nl2br tag="span" :text="item" />
            </div>
          </template>
        </template>
      </div>
      <div class="warning--text" v-if="product.cart_remark">
        {{ $t('Remark') }}: {{ product.cart_remark }}
      </div>

      <div class="price">
        <template v-if="bundleprice != price">
          <span class="discount" style="margin-right: 5px"
            >{{ currencySign }}{{ price | decimalFormat }}</span
          >
          {{ currencySign }}{{ bundleprice | decimalFormat }}
        </template>
        <template v-else
          >{{ currencySign }}{{ price | decimalFormat }}</template
        >
      </div>
      <div
        class="caption text-xs-right"
        v-if="priceBeforeVat && bundleprice != priceBeforeVat"
      >
        {{ $t('Price before VAT') }} {{ currencySign
        }}{{ priceBeforeVat | decimalFormat }}
      </div>

      <div
        style="color: red; font-size: 12px; text-align: right"
        v-if="product.optionDetail && parseInt(product.optionDetail[2]) == 0"
      >
        {{ $t('Sold Out') }}
      </div>
      <div
        style="color: red; font-size: 12px; text-align: right"
        v-else-if="
          parseInt(product.optionDetail && product.optionDetail[2]) <
          product.quantity
        "
      >
        <template v-if="product.optionDetail && product.optionDetail[2] == 1">{{
          $t('Only {item} item left', { item: product.optionDetail[2] })
        }}</template>
        <template v-else>{{
          $t('Only {item} items left', { item: product.optionDetail[2] })
        }}</template>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Nl2br from 'vue-nl2br'
import CheckBundle from '@/components/ecommerce/Bundles/CheckBundle'
export default {
  props: ['product'],
  computed: {
    ...mapGetters({
      isWholesale: 'getWholesaleStatus',
      wholesale: 'getWholesale',
      loadingPageProfile: 'getLoadingPageProfile',
      pageProfile: 'getPageProfile',
      currencySign: 'currencySign'
    }),
    additional_price() {
      let { additional_price } = this.product
      return additional_price
    },
    price() {
      let { price, quantity } = this.product
      return price * quantity + this.additional_price
    },
    bundleprice() {
      let { bundleprice } = this.product
      return bundleprice + this.additional_price
    },
    vat() {
      let { vat } = this.product
      return vat
    },
    priceBeforeVat() {
      let { priceBeforeVat } = this.product
      return priceBeforeVat + this.additional_price
    }
  },
  components: {
    Nl2br,
    CheckBundle
  }
}
</script>

<style scoped></style>
